export default __webpack_public_path__ + "static/media/case-ih-5140-maxxum.05d0289d.jpg";